import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { LifecyclePhase } from "server/models"
import {
    StoreType,
    setLifecyclePath,

    setLifecyclePhaseList,
    setLifecyclePhaseActive,
    setLifecycleConnectionList,
    setLifecycleConnectionActive,
} from "client/store"
import { Link } from "client/components"
import {
    BreadCrumbWrapper,
    BreadCrumbItem,
    BreadCrumbDelimiter,
} from "./styled"

const BreadCrumbs = () => {
    const lifecyclePath = useSelector((state: StoreType) => state.lifecycle.lifecyclePath)
    const lifecycle = useSelector((state: StoreType) => state.lifecycle.lifecycleView)
    const dispatch = useDispatch()

    const openPath = (newLifecyclePath: readonly LifecyclePhase[]) => {
        dispatch(setLifecyclePhaseList([]))
        dispatch(setLifecycleConnectionList([]))
        dispatch(setLifecyclePhaseActive(null))
        dispatch(setLifecycleConnectionActive(null))

        dispatch(setLifecyclePath(newLifecyclePath))
    }

    return (
        <BreadCrumbWrapper>
            <BreadCrumbItem>
                <Link
                    href="/#"
                    onClick={() => {
                        // prevent click on the last item
                        if (!lifecyclePath.length) return
                        openPath([])
                    }}
                >
                    {lifecycle.name}
                </Link>
            </BreadCrumbItem>

            {
                lifecyclePath && lifecyclePath.map((phase: LifecyclePhase, index) => {
                    const newLifecyclePath = lifecyclePath.slice(0, index + 1)
                    return (
                        <BreadCrumbItem key={phase.id}>
                            <BreadCrumbDelimiter />
                            <Link
                                href="/#"
                                onClick={() => {
                                    // prevent click on the last item
                                    if (lifecyclePath.length === newLifecyclePath.length) return
                                    openPath(newLifecyclePath)
                                }}
                            >
                                {phase.name}
                            </Link>
                        </BreadCrumbItem>
                    )
                })
            }
        </BreadCrumbWrapper>
    )
}
export default BreadCrumbs
